'use strict';

// custom transformers & validators
require('../lib/formTransformer/adfinance.stringToDateTime.js');
require('../lib/formTransformer/symfony.numberToLocalizedString.js');

require('../lib/formValidator/adfinance.email');
require('../lib/formValidator/adfinance.phoneNumber');

function hasErrorState(formElement) {
    let errors = formElement.errors || {};

    for(let sourceId in errors) {
        if (!errors.hasOwnProperty(sourceId)) {
            continue;
        }

        if (errors[sourceId].length > 0) {
            return true;
        }
    }

    return false;
}

function findRowForInput(input) {
    return $(input).closest('.form-group, form');
}

function showErrors(errors, sourceId) {
    let $row = findRowForInput(this);
    let rowIsForm = $row.is('form');
    let $errors = $row.find('.form-message').first();
    
    if ($errors.length === 0) {
        $errors = $('<ul class="col-xs-12 form-message form-message-error">').appendTo($row);
    }

    $errors.find('.' + sourceId).remove();
    errors.forEach(function (error, i) {
        $errors.append($('<li>', {
            'class': sourceId,
            'text': errors[i]
        }));
    });

    if (!rowIsForm) {
        $row.toggleClass('has-error', $errors.children().length > 0);
    }
}

function adaptFormElementConstraints(formElement) {
    if (!formElement.domNode) {
        return;
    }

    // opatchovani NotBlank validace
    // pokud je nastaveny globalni priznak disableNotBlank, vraci vzdy true
    // pri on-change validaci povazujeme nevyplnene pole za validni
    let disableNotBlank = false;
    let data = formElement.data;

    for (let type in data) {
        if (!data.hasOwnProperty(type)) {
            continue;
        }

        data[type].constraints.forEach(function(constraint) {
            if (constraint instanceof SymfonyComponentValidatorConstraintsNotBlank) {
                let originalValidator = constraint.validate;
                constraint.validate = function() {
                    if (disableNotBlank) {
                        return [];
                    }

                    return originalValidator.apply(this, arguments);
                }
            }
        });
    }

    // nabindovani validace na change event
    $(formElement.domNode).on('input', function (e) {
        if (this !== e.target) {
            return;
        }

        let $row = findRowForInput(this);
        $row.removeClass('has-success');

        if (!hasErrorState(formElement)) {
            return;
        }

        //noinspection JSUnusedAssignment
        disableNotBlank = true;
        $(formElement.domNode).jsFormValidator('validate');
        disableNotBlank = false;
    });

    $(formElement.domNode).on('change', function (e) {
        if (this !== e.target) {
            return;
        }

        //noinspection JSUnusedAssignment
        disableNotBlank = true;
        $(formElement.domNode).jsFormValidator('validate');
        disableNotBlank = false;

        let $row = findRowForInput(this);

        let isValid = $row.find(':input').toArray()
            .map((input) => $(input).jsFormValidator('validate'))
            .reduce((v, c) => v && c, true)
        ;

        $row.toggleClass('has-success', !$row.hasClass('has-error') && $(this).val() !== '' && !hasErrorState(formElement));
    });
}

function adaptFormElementErrors(formElement) {
    formElement.showErrors = showErrors;
}

function adaptFormElementRecursive(formElement) {
    adaptFormElementErrors(formElement);
    adaptFormElementConstraints(formElement);

    let children = formElement.children;
    for (let name in children) {
        if (!children.hasOwnProperty(name)) {
            continue;
        }

        adaptFormElementRecursive(children[name]);
    }
}

export function setCustomizeValidators() {
    for (let name in FpJsFormValidator.forms) {
        if (!FpJsFormValidator.forms.hasOwnProperty(name)) {
            continue;
        }

        adaptFormElementRecursive(FpJsFormValidator.forms[name]);

        FpJsFormValidator.customize(FpJsFormValidator.forms[name].domNode, {
            onValidate: function(errors) {
                let topMostErrorId = null;
                let topMostErrorPosition = null;

                for (let id in errors) {
                    if (!errors.hasOwnProperty(id)) {
                        continue;
                    }

                    // pozici hledame podle obalujiciho radku
                    // input jako takovy muze byt napr pres media-query skryty
                    let fieldPosition = findRowForInput('#' + id).offset().top;

                    if (topMostErrorPosition === null || topMostErrorPosition > fieldPosition) {
                        topMostErrorPosition = fieldPosition;
                        topMostErrorId = id;
                    }
                }

                if (topMostErrorId === null) {
                    return;
                }

                $('#' + topMostErrorId).closest('.form-group').scrollTo(1000);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/form.validation.js